export default __webpack_public_path__ + "static/media/blog-post-layout-02-img-07.4a9a1d7c.jpg";